import React, { useCallback, useRef, useState } from 'react'
import { toast } from 'sonner'
import HttpClient from '../../../../services/HttpClient'
import StatAllocationPanel from '../../shared/StatAllocationPanel'

/**
 * Modal obligatorio para reasignar atributos (flag statsReallocPending).
 */
export default function StatsReallocModal({ slug, level = 10, onComplete }) {
  const allocRef = useRef({ valid: false, stats: null })
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)

  const onValidChange = useCallback((payload) => {
    allocRef.current = payload
  }, [])

  const submit = async () => {
    const { valid, stats } = allocRef.current || {}
    if (!valid || !stats) {
      setError('Completa la asignación (20 aleatorios + 30 manuales = 50).')
      return
    }
    setBusy(true)
    setError(null)
    try {
      const res = await HttpClient().post(`/api/v1/characters/${slug}/stats/realloc`, { stats })
      // HttpClient unwraps { success, data } → res.success + res.data = payload
      const payload = res?.data
      if (res?.success !== true) {
        throw new Error(res?.message || payload?.message || 'No se pudo guardar')
      }
      toast.success('Atributos reasignados')
      onComplete?.(payload)
    } catch (e) {
      const status = e?.response?.status || e?.status
      const code = e?.response?.data?.code || e?.code
      const msg =
        e?.response?.data?.message || e?.message || 'Error al reasignar atributos'
      // Ya guardado en servidor (intento previo OK pero UI no cerró): refrescar y cerrar.
      if (status === 409 || code === 'NOT_PENDING') {
        toast.success('Atributos ya actualizados')
        onComplete?.(null)
        return
      }
      setError(msg)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="stat-realloc-overlay" role="dialog" aria-modal="true" aria-labelledby="stat-realloc-title">
      <div className="stat-realloc-modal">
        <p className="stat-realloc-modal__banner" id="stat-realloc-title">
          Se han hecho cambios en las estadísticas de la ficha de personaje y se han reseteado los puntos. Necesitas
          repartir tus 30 puntos para poder seguir roleando.
        </p>
        <StatAllocationPanel
          level={level}
          title="Reasignar atributos"
          onValidChange={onValidChange}
        />
        {error ? (
          <p className="stat-realloc-modal__error" role="alert">
            {error}
          </p>
        ) : null}
        <div className="stat-realloc-modal__actions">
          <button
            type="button"
            className="stat-realloc-modal__submit"
            disabled={busy}
            onClick={submit}
          >
            {busy ? 'Guardando…' : 'Confirmar asignación'}
          </button>
        </div>
      </div>
    </div>
  )
}
